import React, { useState } from "react";
import { Link, animateScroll as scroll } from "react-scroll";

const Navbar = () => {
  const [isOpen, setisOpen] = useState(false);
  const drawer = () => {
    setisOpen(!isOpen);
    console.log("isOpen", isOpen);
  };
  return (
    <div>
      <header class="text-gray-400 bg-gray-900 body-font">
        <div class="container mx-auto flex flex-wrap p-5 flex-row md:flex-row items-center">
          <a class="flex title-font font-medium items-center text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
              />
            </svg>

            <span class="ml-3 text-xl md:text-2xl">Developer</span>
          </a>
          <nav
            className="ml-auto md:hidden"
            onClick={() => {
              drawer();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </nav>
          {/* Nav */}
          <nav class="hidden md:block md:ml-auto flex flex-wrap flex-col sm:flex-row items-center text-base justify-center">
            <Link
              to="About"
              smooth={true}
              class="mr-5 hover:text-white cursor-pointer"
            >
              About me
            </Link>
            <Link
              to="Services"
              smooth={true}
              class="mr-5 hover:text-white cursor-pointer"
            >
              Skills
            </Link>
            <Link
              to="Projects"
              smooth={true}
              class="mr-5 hover:text-white cursor-pointer"
            >
              Projects
            </Link>
            {/* <Link
              to="OurTeam"
              smooth={true}
              class="mr-5 hover:text-white cursor-pointer"
            >
              Our Team
            </Link> */}
            <Link
              to="ContactUs"
              smooth={true}
              class="inline-flex items-center bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-indigo-700 rounded text-white mt-4 md:mt-0 cursor-pointer"
            >
              Contact Me
              <svg
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                class="w-4 h-4 ml-1"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7"></path>
              </svg>
            </Link>
          </nav>
        </div>
        {/* mobile-nav */}
        <nav
          class={` ${
            !isOpen ? "hidden" : ""
          } flex flex-col items-center text-white justify-center `}
        >
          <Link to="About" smooth={true} class="m-5 hover:text-white">
            About me
          </Link>
          <Link to="Services" smooth={true} class="m-5 hover:text-white">
            Skills
          </Link>
          <Link to="Projects" smooth={true} class="m-5 hover:text-white">
            Projects
          </Link>
          {/* <Link to="OurTeam" smooth={true} class="m-5 hover:text-white">
            Our Team
          </Link> */}
          <Link
            to="ContactUs"
            smooth={true}
            class="inline-flex items-center bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-indigo-700 rounded text-white my-4 md:mt-0"
          >
            Contact me
            <svg
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              class="w-4 h-4 ml-1"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7"></path>
            </svg>
          </Link>
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
